import percentageIcon from "../../assets/icons/Minus-icon.svg";
import fraseIkon from "../../assets/icons/Paper-icon + circle.svg";

export default function FeatureTableBox() {
  return (
    <div className="relative shadow-2xl py-6 bg-white rounded-3xl">
      <div className="absolute hidden md:block  left-[-105px] top-[230px]">
        <img src={fraseIkon} width={199} alt="Fraseikon" />
      </div>
      <table className="w-full text-[16px] text-left rtl:text-right text-gray-700">
        <thead className="text-doctio-dark">
          <tr>
            <th scope="col" className="md:px-2 py-3">
              <h2 className="text-doctio-dark ml-6 text-left hidden md:block mx-auto md:text-d2xl">
                Funktion
              </h2>
            </th>

            <th scope="col" className="md:px-2 py-3">
              <h2 className="text-doctio-dark text-center mr-5 grayscale opacity-50 md:mr-0 md:text-d2xl">
                <span className="hidden md:inline mr-2">Doctio</span>
                Basic
              </h2>
            </th>
            <th scope="col" className="md:px-2 py-3">
              <h2 className="text-doctio-dark text-center md:text-d2xl">
                <span className="hidden md:inline mr-2">Doctio</span>
                <span>Pro</span>
              </h2>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="even:bg-white odd:bg-doctio-lightgreen rounded">
            <th
              scope="row"
              className="md:px-2 py-4 ml-8 font-medium flex w-full justify-between relative mx-auto text-[16px] md:text-[17px] text-doctio-dark whitespace-nowrap w-full"
            >
              Pris
            </th>

            <td className="md:px-2 py-4">
              <p className="text-doctio-dark mb-0 mt-0 text-center text-dxl font-bold opacity-50">
                Gratis
              </p>
            </td>
            <td className="md:px-2 py-4">
              <p className="text-doctio-green mb-0 mt-0 text-dxl text-center font-bold">
                179,-/md
              </p>
            </td>
          </tr>
          <tr className="even:bg-white odd:bg-doctio-lightgreen rounded">
            <th
              scope="row"
              className="md:px-2 py-4 ml-8 font-medium flex w-full justify-between relative mx-auto text-[16px] md:text-[17px] text-doctio-dark whitespace-nowrap w-full"
            >
              Tekstfraser
            </th>

            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 grayscale opacity-50 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>
          <tr className="even:bg-white odd:bg-doctio-lightgreen rounded-lg">
            <th
              scope="row"
              className="md:px-2 py-4 ml-8 rounded-lg font-medium flex w-full justify-between relative  text-[16px] md:text-[17px] text-doctio-dark whitespace-nowrap w-full"
            >
              Klikfraser
            </th>

            <td className="md:px-2 py-4">
              <p className="text-doctio-green grayscale mb-0 mt-0 text-[1.7rem] text-center opacity-50 font-bold">
                Udvalgte
              </p>
            </td>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>
          <tr className="even:bg-white odd:bg-doctio-lightgreen rounded">
            <th
              scope="row"
              className="md:px-2 py-4 ml-8 font-medium flex w-full justify-between relative mx-auto text-[16px] md:text-[17px] text-doctio-dark whitespace-nowrap w-full"
            >
              Opret/rediger fraser
            </th>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 grayscale opacity-50 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>
          <tr className="even:bg-white odd:bg-doctio-lightgreen rounded">
            <th
              scope="row"
              className="md:px-2 py-4 ml-24 relative flex justify-between mx-auto font-medium text-[16px] md:text-[17px] text-doctio-dark whitespace-nowrap w-full"
            >
              DoctioAssist
            </th>
            <td className="md:px-2 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-8 mr-4 opacity-50 grayscale md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>
          <tr className="even:bg-white odd:bg-doctio-lightgreen rounded">
            <th
              scope="row"
              className="md:px-2 py-4 ml-28 font-medium flex w-full justify-between mx-auto text-[16px] relative md:text-[17px] text-doctio-dark whitespace-nowrap w-full"
            >
              Vis-skjul afsnit
            </th>
            <td className="md:px-2 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-8 mr-4 opacity-50 grayscale md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>
          <tr className="even:bg-white odd:bg-doctio-lightgreen rounded">
            <th
              scope="row"
              className="md:px-2 py-4 ml-24 font-medium flex relative justify-between mx-auto text-[16px] md:text-[17px] text-doctio-dark whitespace-nowrap w-full"
            >
              Logik
            </th>
            <td className="md:px-2 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-8 mr-4 opacity-50 grayscale md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>

          <tr className="even:bg-white odd:bg-doctio-lightgreen rounded">
            <th
              scope="row"
              className="md:px-2 py-4 ml-8 font-medium flex relative justify-between mx-auto text-[16px] md:text-[17px] text-doctio-dark whitespace-nowrap w-full"
            >
              Del fraser
            </th>
            <td className="md:px-2 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-8 mr-4 opacity-50 grayscale md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>

          <tr className="even:bg-white odd:bg-doctio-lightgreen rounded">
            <th
              scope="row"
              className="md:px-2 py-4 ml-8 font-medium flex relative justify-between mx-auto text-[16px] md:text-[17px] text-doctio-dark whitespace-nowrap w-full"
            >
              Medarbejder adminstration
            </th>
            <td className="md:px-2 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-8 mr-4 opacity-50 grayscale md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>

          <tr className="even:bg-white odd:bg-doctio-lightgreen rounded">
            <th
              scope="row"
              className="md:px-2 py-4 ml-8 font-medium flex relative justify-between mx-auto text-[16px] md:text-[17px] text-doctio-dark whitespace-nowrap w-full"
            >
              Noter
            </th>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 opacity-50 grayscale md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>

          <tr className="even:bg-white odd:bg-doctio-lightgreen rounded">
            <th
              scope="row"
              className="md:px-2 py-4 ml-8 font-medium flex relative justify-between mx-auto text-[16px] md:text-[17px] text-doctio-dark whitespace-nowrap w-full"
            >
              Medier
            </th>
            <td className="md:px-2 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-8 mr-4 opacity-50 grayscale md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>

          <tr className="even:bg-white odd:bg-doctio-lightgreen rounded">
            <th
              scope="row"
              className="md:px-2 py-4 ml-8 font-medium flex relative justify-between mx-auto text-[16px] md:text-[17px] text-doctio-dark whitespace-nowrap w-full"
            >
              Dokumentsamling
            </th>
            <td className="md:px-2 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-8 mr-4 opacity-50 grayscale md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>
          <tr className="even:bg-white odd:bg-doctio-lightgreen rounded">
            <th
              scope="row"
              className="md:px-2 py-4 ml-8 font-medium flex relative justify-between mx-auto text-[16px] md:text-[17px] text-doctio-dark whitespace-nowrap w-full"
            >
              Løbende ajourføring
            </th>
            <td className="md:px-2 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-8 mr-4 opacity-50 grayscale md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>
          <tr className="even:bg-white odd:bg-doctio-lightgreen rounded">
            <th
              scope="row"
              className="md:px-2 py-4 ml-8 font-medium flex relative justify-between mx-auto text-[16px] md:text-[17px] text-doctio-dark whitespace-nowrap w-full"
            >
              Ingen reklamer
            </th>
            <td className="md:px-2 py-4">
              <img
                src={percentageIcon}
                width={15}
                className="ml-8 mr-4 opacity-50 grayscale md:mx-auto"
                alt="percentage icon"
              />
            </td>
            <td className="md:px-2 py-4">
              <svg
                className="ml-8 mr-4 md:mx-auto"
                fill="#1f7672"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 22.476 20"
                width="21px"
                height="21px"
              >
                <g id="Group_2813" data-name="Group 2813">
                  <path
                    id="Path_8102"
                    data-name="Path 8102"
                    d="M25.488,8.983l-9.443,12.49L11.973,16.2a2.5,2.5,0,1,0-3.947,3.073l6.07,7.769a2.506,2.506,0,0,0,3.947-.025L29.46,12.031a2.513,2.513,0,1,0-4-3.048Z"
                    transform="translate(-7.499 -7.994)"
                    fill="#1f7672"
                  />
                </g>{" "}
              </svg>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
